import Vue from 'vue'
import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'
import OtpInput from '@bachdgvn/vue-otp-input'
import StarRating from '../../components/StarComponent/index.vue'
import JobService from '../../services/jobService'
import { showErrorToast, showSuccessToast } from '../../services/UI'
Vue.component('v-otp-input', OtpInput)
export default {
  name: 'earningsModal',
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  data () {
    return {
      mutableActived: this.activated,
      comment: '',
      rating: 0,
      time: ''
    }
  },
  components: {
    StarRating
  },
  props: ['activated', 'closeEarningsModal', 'id', 'logId', 'startT', 'endT'],
  methods: {
    handleFileChange (e) {
      this.$emit('input', e.target.files[0])
    },
    close () {
      this.closeEarningsModal(true)
      this.mutableActived = !this.mutableActived
      this.$el.blur()
      this.rating = 0
      this.comment = ''
    },
    getStars (stars) {
      this.rating = stars
    },
    async approveTime () {
      // console.log(this.rating)
      // if (this.rating < 1) {
      //   showErrorToast(this, 'Rating cannot be 0 stars')
      //   return
      // }
      // if (this.comment.length === 0) {
      //   showErrorToast(this, 'Comment should not be empty')
      //   return
      // }
      const res = await JobService.approveMiniJobShiftLog(this.id, this.logId, this.comment, this.rating)
      if (res) {
        showSuccessToast(this, 'Shift Approved Successfully')
      } else {
        showErrorToast(this, 'Error Approving Shift')
      }
      this.close()
    },
    timeDiffCalc (dateFuture, dateNow) {
      let diffInMilliSeconds = Math.abs(dateFuture - dateNow) / 1000
  
      const days = Math.floor(diffInMilliSeconds / 86400)
      diffInMilliSeconds -= days * 86400
      // console.log('calculated days', days)
  
      const hours = Math.floor(diffInMilliSeconds / 3600) % 24
      diffInMilliSeconds -= hours * 3600
      // console.log('calculated hours', hours)
  
      const minutes = Math.floor(diffInMilliSeconds / 60) % 60
      diffInMilliSeconds -= minutes * 60
      // console.log('minutes', minutes)
  
      let difference = ''
      if (days > 0) {
        difference += (days === 1) ? `${days} day, ` : `${days} days, `
      }
  
      difference += (hours === 0 || hours === 1) ? `${hours} hour ` : `${hours} hours `
  
      difference += (minutes === 0 || hours === 1) ? `${minutes} minutes` : `${minutes} minutes`
  
      return difference
    }
  },
  watch: {
    activated (oldVal, newVal) {
      if (oldVal !== newVal && oldVal !== null) {
        this.mutableActived = !this.mutableActived
        this.$el.tabIndex = 1
        this.$nextTick(function () {
          this.$el.focus()
        })
      }
      // console.log(this.id, this.logId)
      // this.diff_hours(this.startT, this.endT)
      // console.log(this.timeDiffCalc(new Date(parseInt(this.startT)), new Date(parseInt(this.endT))))
      this.time = this.timeDiffCalc(new Date(parseInt(this.startT)), new Date(parseInt(this.endT)))
    }
  }
}
